
import { of as observableOf, Observable } from 'rxjs';

import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute, CanLoad } from '@angular/router';

import { SessionService } from '../_services/session.service';
import { environment } from '../../environments/environment';

@Injectable()
export class AuthGuard implements CanActivate, CanLoad {

    constructor(private router: Router, private sessionService: SessionService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        return this.sessionService.getSessionActive().pipe(map(loggedIn => {

            if (!loggedIn.Succeed) {
                var parameters = Object.assign({}, route.queryParams);
                var indexOfParameters = state.url.indexOf('?');
                if (indexOfParameters > 0) {
                    parameters["returnUrl"] = state.url.substring(0, indexOfParameters);
                }
                else {
                    parameters["returnUrl"] = state.url;
                }
                this.router.navigate(['/login'], { queryParams: parameters });
            }
            else {
                this.sessionService.setCurrentUser(loggedIn.Data);
                // if (state.url == "" || state.url == "/app/inicio") this.router.navigate([this.sessionService.obtenerUrlInicial()], { queryParams: parameters });
            }

            // let verificacionOk: boolean = (loggedIn.Succeed && (this.sessionService.puedeAccederARuta(state.url) || !environment.production));
            let verificacionOk: boolean = loggedIn.Succeed;

            return verificacionOk;

        }), catchError(() => {
            this.router.navigate(['/NoConnection'], { queryParams: { returnUrl: state.url } });
            return observableOf(false);
        }));
    }

    canLoad(route: import("@angular/router").Route, segments: import("@angular/router").UrlSegment[]): boolean | Observable<boolean> | Promise<boolean> {
        return this.sessionService.getSessionActive().pipe(map(loggedIn => {
            let ruta = "/" + segments.map(seg => seg.path).join("/");
            var parameters = { returnUrl: ruta };

            if (!loggedIn.Succeed) this.router.navigate(['/login'], { queryParams: parameters });

            return loggedIn.Succeed;

        }), catchError(() => {
            return observableOf(false);
        }));
    }

}